import { StyleSheet } from "@react-pdf/renderer";

import "../fonts";

export const colors = {
  text: "#1a1a1a",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  background: "#ffffff",
  warning: "#f69a0e",
};

export const PAGE_PADDING_HORIZONTAL = 48;

export const pageStyles = StyleSheet.create({
  page: {
    fontFamily: "NotoSansJP",
    backgroundColor: colors.background,
    paddingTop: 40,
    paddingBottom: 40,
    paddingHorizontal: PAGE_PADDING_HORIZONTAL,
  },
});

export const sectionStyles = StyleSheet.create({
  container: {
    maxHeight: "100%",
    flex: 1,
    display: "flex",
    gap: 12,
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: colors.text,
  },
  summaryTextContainer: {},
  summaryText: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  noData: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.warning,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  chartImageContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  chartImage: {
    objectFit: "contain",
  },
  subTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: colors.text,
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    gap: 6,
  },
  listBullet: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  listItemText: {
    flex: 1,
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  numberedListItem: {
    display: "flex",
    flexDirection: "row",
    gap: 6,
    width: "100%",
  },
  listNumberContainer: {},
  listNumber: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  contentContainer: {
    flex: 1,
  },
  commentTitle: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  commentExample: {
    fontSize: 9,
    fontWeight: 400,
    color: colors.textMuted,
  },
  commentsRow: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    gap: 24,
    alignItems: "flex-start",
  },
  commentsColumn: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  reviewsCommentsImageContainer: {
    width: 250,
    height: 200,
    alignSelf: "center",
  },
  reviewsTimelineContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
});
